import CreateConnectionView from "@features/tools/view/connections-view/create-connection-view";

const CreateConnection = () => {
  return <CreateConnectionView />;
};

export default CreateConnection;
